import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface MarketingReferralDataState {
  referralCode: string
}

const initialState: MarketingReferralDataState = {
  referralCode: "",
}

const marketingReferralDataSlice = createSlice({
  name: "referral-data",
  initialState,
  reducers: {
    setReferralData: (state, action: PayloadAction<string>) => {
      state.referralCode = action.payload
    },
  },
})

export const { setReferralData } = marketingReferralDataSlice.actions
export default marketingReferralDataSlice.reducer
